/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
var LogBox = {
  ignoreLogs: function ignoreLogs() {},
  ignoreAllLogs: function ignoreAllLogs() {},
  uninstall: function uninstall() {},
  install: function install() {}
};
export default LogBox;
